
export const namespaced = true // ensures all mutations, actions and getters are namespaced under event.

export const state = {
    place: null, // the searched place
    center: {lat: 50.5, lng: 10}, // the map center
    defaultCenter: {lat: 50.5, lng: 10}, // the default map center
    radius: 50, // the radius to search related to searched location
    zoom: 6,
    liveSearch: true
}

export const mutations = {
    SET_PLACE (state, place) {
        state.place = place
    },
    SET_RADIUS (state, radius) {
        state.radius = radius
    },
    SET_CENTER (state, place) {
        if (place && place.geometry) {
            let lat, lng
            if (place.geometry.location) {
                if (typeof (place.geometry.location.lat) === 'number') {
                    lat = place.geometry.location.lat
                    lng = place.geometry.location.lng
                } else {
                    lat = place.geometry.location.lat()
                    lng = place.geometry.location.lng()
                }
            } else if (state.place.geometry.locationFromNavigator) {
                lat = state.place.geometry.locationFromNavigator.lat
                lng = state.place.geometry.locationFromNavigator.lng
            } else {
                lat = place.geometry.lat
                lng = place.geometry.lng
            }
            state.center = {
                lat: lat + (Math.floor(Math.random() * 9) + 1) * 0.000001,
                lng: lng + (Math.floor(Math.random() * 9) + 1) * 0.000001
            }
        } else {
            state.center = state.defaultCenter
        }
    },
    SET_ZOOM (state, distance) {
        if (distance !== 0) {
            if (state.radius === 50) {
                if (distance >= 10 && distance < 20) {
                    state.zoom = 11
                } else if (distance >= 20 && distance < 30) {
                    state.zoom = 10
                } else if (distance >= 30 && distance < 40) {
                    state.zoom = 9
                } else if (distance >= 40 && distance < 50) {
                    state.zoom = 8
                } else {
                    state.zoom = 12
                }
            } else {
                if (distance >= 50 && distance < 90) {
                    state.zoom = 7
                } else if (distance <= 90 && distance < 150) {
                    state.zoom = 6
                } else if (distance >= 150) {
                    state.zoom = 5
                }
            }
        } else {
            state.zoom = 6
        }
    },
    SET_LIVE_SEARCH (state, data) {
        state.liveSearch = data
    }
}

export const actions = {
    updatePlace ({ commit }, place) {
        commit('SET_PLACE', place)
        commit('SET_CENTER', place)
    },
    updateRadius ({ commit }, radius) {
        commit('SET_RADIUS', radius)
    },
    updateZoom ({ commit }, distance) {
        commit('SET_ZOOM', distance)
    },
    disableLiveSearch ({ commit }) {
        commit('SET_LIVE_SEARCH', false)
    }
}
